import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/** Ruta al perfil de quien aparece en la Caja (Carlos 29-sep: «si tiene perfil, que le pueda dar
 *  clic»). Alumna → /alumnos/:contact_id. Maestro → /profesores/:user_id, pero SOLO si la API dice
 *  que tiene ficha de profesor (esProfesor en el backend): recepción (Mabel, Aracely) no tiene
 *  perfil y un enlace ahí acabaría en «no encontrado». */
export function rutaPerfil(o: { contactId?: number | null; userId?: number | null; esProfe?: unknown }): string | null {
  if (o.contactId) return `/alumnos/${o.contactId}`;
  if (o.userId && Number(o.esProfe)) return `/profesores/${o.userId}`;
  return null;
}

/** El nombre (y su foto, si va dentro) como enlace al perfil; sin perfil, se pinta igual pero sin enlace. */
export default function PerfilLink({ to, className = '', title, children }: { to: string | null; className?: string; title?: string; children: ReactNode }) {
  if (!to) return <span className={className} title={title}>{children}</span>;
  return (
    <Link to={to} title={title ? `${title} · ver perfil` : 'Ver perfil'}
      className={`${className} underline-offset-2 transition hover:text-accent-content hover:underline`}>
      {children}
    </Link>
  );
}
